import React from 'react';
import Typography from '@material-ui/core/Typography';
import {
  formatFullTableDate,
  getMeasureHistoryDisplayValue,
  getMeasureHistoryRows,
} from '../../MeasuresContext/utils/utils';
import {
  nonGraphablePreviewRowCount,
  smallWidgetNonGraphablePreviewRowCount,
} from '../../MeasuresContext/utils/constants';
import { NonGraphableHistoryPreview } from '../../../components/layout/WrapperDiv';
import defaults from '../../../translations/en.json';

type MeasuresHistoryPreviewProps = {
  measures: mumms.measure[];
  chartHeight: number;
  border?: string;
  marginLeft?: number;
  smallWidget?: boolean;
};

const texts: NonNullable<mumms.JSONObject> = defaults;

export const MeasuresHistoryPreview = React.memo(
  ({
    measures,
    chartHeight,
    border,
    marginLeft = 60,
    smallWidget,
  }: MeasuresHistoryPreviewProps) => {
    const rows = getMeasureHistoryRows(measures);
    const previewRowCount = smallWidget
      ? smallWidgetNonGraphablePreviewRowCount
      : nonGraphablePreviewRowCount;
    const previewRows = rows.slice(0, previewRowCount);
    const remaining = rows.length - previewRows.length;

    return (
      <NonGraphableHistoryPreview
        chartHeight={chartHeight}
        border={border}
        marginLeft={smallWidget ? 0 : marginLeft}
        allowWrap={!!smallWidget}
      >
        {previewRows.length === 0 ? (
          <Typography variant="body2" className="preview-empty">
            {texts.historyNoEntries}
          </Typography>
        ) : (
          previewRows.map((row) => (
            <div
              key={row.id || `${row.measuredatetimeshifted}-${row.value}`}
              className="preview-row"
            >
              <span className="preview-date">
                {formatFullTableDate(
                  row.visitdatetimeshifted || row.measuredatetimeshifted,
                )}
              </span>
              <span className="preview-value">
                {getMeasureHistoryDisplayValue(row)}
              </span>
            </div>
          ))
        )}
        {remaining > 0 && (
          <Typography variant="caption" className="preview-more">
            … {remaining} {texts.historyMoreEntries}
          </Typography>
        )}
      </NonGraphableHistoryPreview>
    );
  },
);

export default MeasuresHistoryPreview;
